import React from "react"

export const IconMailbox = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 6C4.80653 6 3.66193 6.47411 2.81802 7.31802C1.97411 8.16193 1.5 9.30653 1.5 10.5V19.5H10.5V10.5C10.5 9.30653 10.0259 8.16193 9.18198 7.31802C8.33807 6.47411 7.19347 6 6 6ZM6 4.5H18C19.5913 4.5 21.1174 5.13214 22.2426 6.25736C23.3679 7.38258 24 8.9087 24 10.5V19.5C24 19.8978 23.842 20.2794 23.5607 20.5607C23.2794 20.842 22.8978 21 22.5 21H1.5C1.10218 21 0.720644 20.842 0.43934 20.5607C0.158035 20.2794 0 19.8978 0 19.5V10.5C0 8.9087 0.632141 7.38258 1.75736 6.25736C2.88258 5.13214 4.4087 4.5 6 4.5ZM9.969 6C10.6081 6.56246 11.1199 7.25482 11.4701 8.03082C11.8204 8.80682 12.001 9.64862 12 10.5V19.5H22.5V10.5C22.5 9.30653 22.0259 8.16193 21.182 7.31802C20.3381 6.47411 19.1935 6 18 6H9.969Z"
          fill="#1D262D"
        />
        <path
          d="M17.6895 12.75H13.5V11.25H21C21.1989 11.25 21.3897 11.329 21.5303 11.4697C21.671 11.6103 21.75 11.8011 21.75 12V13.5C21.75 13.6989 21.671 13.8897 21.5303 14.0303C21.3897 14.171 21.1989 14.25 21 14.25H19.5C19.4014 14.2502 19.3038 14.2309 19.2127 14.1933C19.1216 14.1558 19.0388 14.1006 18.969 14.031L17.6895 12.75ZM7.5 10.5C7.5 11.328 6.828 10.5 6 10.5C5.172 10.5 4.5 11.328 4.5 10.5C4.5 10.1022 4.65804 9.72064 4.93934 9.43934C5.22064 9.15804 5.60218 9 6 9C6.39782 9 6.77936 9.15804 7.06066 9.43934C7.34196 9.72064 7.5 10.1022 7.5 10.5Z"
          fill="#1D262D"
        />
      </svg>
    </>
  )
}
export const IconMailboxBrand = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 6C4.80653 6 3.66193 6.47411 2.81802 7.31802C1.97411 8.16193 1.5 9.30653 1.5 10.5V19.5H10.5V10.5C10.5 9.30653 10.0259 8.16193 9.18198 7.31802C8.33807 6.47411 7.19347 6 6 6ZM6 4.5H18C19.5913 4.5 21.1174 5.13214 22.2426 6.25736C23.3679 7.38258 24 8.9087 24 10.5V19.5C24 19.8978 23.842 20.2794 23.5607 20.5607C23.2794 20.842 22.8978 21 22.5 21H1.5C1.10218 21 0.720644 20.842 0.43934 20.5607C0.158035 20.2794 0 19.8978 0 19.5V10.5C0 8.9087 0.632141 7.38258 1.75736 6.25736C2.88258 5.13214 4.4087 4.5 6 4.5ZM9.969 6C10.6081 6.56246 11.1199 7.25482 11.4701 8.03082C11.8204 8.80682 12.001 9.64862 12 10.5V19.5H22.5V10.5C22.5 9.30653 22.0259 8.16193 21.182 7.31802C20.3381 6.47411 19.1935 6 18 6H9.969Z"
          fill="#D07A25"
        />
        <path
          d="M17.6895 12.75H13.5V11.25H21C21.1989 11.25 21.3897 11.329 21.5303 11.4697C21.671 11.6103 21.75 11.8011 21.75 12V13.5C21.75 13.6989 21.671 13.8897 21.5303 14.0303C21.3897 14.171 21.1989 14.25 21 14.25H19.5C19.4014 14.2502 19.3038 14.2309 19.2127 14.1933C19.1216 14.1558 19.0388 14.1006 18.969 14.031L17.6895 12.75ZM7.5 10.5C7.5 11.328 6.828 10.5 6 10.5C5.172 10.5 4.5 11.328 4.5 10.5C4.5 10.1022 4.65804 9.72064 4.93934 9.43934C5.22064 9.15804 5.60218 9 6 9C6.39782 9 6.77936 9.15804 7.06066 9.43934C7.34196 9.72064 7.5 10.1022 7.5 10.5Z"
          fill="#D07A25"
        />
      </svg>
    </>
  )
}

export const IconCode = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.717 2.47049C15.746 2.37633 15.7561 2.27739 15.7468 2.17932C15.7375 2.08125 15.709 1.98596 15.6629 1.89891C15.6168 1.81185 15.554 1.73473 15.4781 1.67195C15.4022 1.60916 15.3147 1.56194 15.2205 1.53299C15.1263 1.50403 15.0274 1.4939 14.9293 1.50318C14.8313 1.51246 14.736 1.54097 14.6489 1.58707C14.5619 1.63318 14.4847 1.69598 14.422 1.77189C14.3592 1.8478 14.312 1.93533 14.283 2.02949L8.283 21.5295C8.22452 21.7196 8.24397 21.9253 8.33708 22.1011C8.4302 22.2769 8.58934 22.4085 8.7795 22.467C8.96966 22.5255 9.17526 22.506 9.35108 22.4129C9.52689 22.3198 9.65852 22.1606 9.717 21.9705L15.717 2.47049ZM7.281 6.21899C7.35084 6.28866 7.40626 6.37142 7.44407 6.46254C7.48188 6.55365 7.50134 6.65134 7.50134 6.74999C7.50134 6.84864 7.48188 6.94632 7.44407 7.03744C7.40626 7.12856 7.35084 7.21132 7.281 7.28099L2.5605 12L7.281 16.719C7.42183 16.8598 7.50094 17.0508 7.50094 17.25C7.50094 17.4492 7.42183 17.6402 7.281 17.781C7.14017 17.9218 6.94916 18.0009 6.75 18.0009C6.55083 18.0009 6.35983 17.9218 6.219 17.781L0.968998 12.531C0.899153 12.4613 0.843739 12.3786 0.805929 12.2874C0.768119 12.1963 0.748657 12.0986 0.748657 12C0.748657 11.9013 0.768119 11.8037 0.805929 11.7125C0.843739 11.6214 0.899153 11.5387 0.968998 11.469L6.219 6.21899C6.28867 6.14914 6.37143 6.09373 6.46255 6.05592C6.55366 6.01811 6.65135 5.99865 6.75 5.99865C6.84865 5.99865 6.94633 6.01811 7.03745 6.05592C7.12857 6.09373 7.21133 6.14914 7.281 6.21899ZM16.719 6.21899C16.6492 6.28866 16.5937 6.37142 16.5559 6.46254C16.5181 6.55365 16.4987 6.65134 16.4987 6.74999C16.4987 6.84864 16.5181 6.94632 16.5559 7.03744C16.5937 7.12856 16.6492 7.21132 16.719 7.28099L21.4395 12L16.719 16.719C16.6493 16.7887 16.594 16.8715 16.5562 16.9626C16.5185 17.0537 16.499 17.1514 16.499 17.25C16.499 17.3486 16.5185 17.4463 16.5562 17.5374C16.594 17.6285 16.6493 17.7113 16.719 17.781C16.7887 17.8507 16.8715 17.906 16.9626 17.9438C17.0537 17.9815 17.1514 18.0009 17.25 18.0009C17.3486 18.0009 17.4463 17.9815 17.5374 17.9438C17.6285 17.906 17.7113 17.8507 17.781 17.781L23.031 12.531C23.1008 12.4613 23.1563 12.3786 23.1941 12.2874C23.2319 12.1963 23.2513 12.0986 23.2513 12C23.2513 11.9013 23.2319 11.8037 23.1941 11.7125C23.1563 11.6214 23.1008 11.5387 23.031 11.469L17.781 6.21899C17.7113 6.14914 17.6286 6.09373 17.5374 6.05592C17.4463 6.01811 17.3486 5.99865 17.25 5.99865C17.1513 5.99865 17.0537 6.01811 16.9625 6.05592C16.8714 6.09373 16.7887 6.14914 16.719 6.21899Z"
          fill="black"
        />
      </svg>
    </>
  )
}

export const IconChat = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.375 20.2493H4.46875C4.27813 20.2493 4.09531 20.1735 3.96052 20.0388C3.82573 19.904 3.75 19.7211 3.75 19.5305V11.6242C3.75 10.4916 3.97309 9.37004 4.40654 8.32361C4.83998 7.27718 5.4753 6.32637 6.2762 5.52547C7.0771 4.72456 8.02791 4.08925 9.07435 3.6558C10.1208 3.22236 11.2423 2.99927 12.375 2.99927H12.375C13.5077 2.99927 14.6292 3.22236 15.6756 3.65581C16.7221 4.08925 17.6729 4.72457 18.4738 5.52547C19.2747 6.32638 19.91 7.27719 20.3435 8.32362C20.7769 9.37006 21 10.4916 21 11.6243V11.6243C21 13.9118 20.0913 16.1056 18.4738 17.7231C16.8563 19.3406 14.6625 20.2493 12.375 20.2493Z"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.375 13.125C12.9963 13.125 13.5 12.6213 13.5 12C13.5 11.3787 12.9963 10.875 12.375 10.875C11.7537 10.875 11.25 11.3787 11.25 12C11.25 12.6213 11.7537 13.125 12.375 13.125Z"
          fill="black"
        />
        <path
          d="M7.875 13.125C8.49632 13.125 9 12.6213 9 12C9 11.3787 8.49632 10.875 7.875 10.875C7.25368 10.875 6.75 11.3787 6.75 12C6.75 12.6213 7.25368 13.125 7.875 13.125Z"
          fill="black"
        />
        <path
          d="M16.875 13.125C17.4963 13.125 18 12.6213 18 12C18 11.3787 17.4963 10.875 16.875 10.875C16.2537 10.875 15.75 11.3787 15.75 12C15.75 12.6213 16.2537 13.125 16.875 13.125Z"
          fill="black"
        />
      </svg>
    </>
  )
}

export const IconLightmode = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 0C12.2893 0 12.5668 0.114935 12.7714 0.31952C12.976 0.524105 13.0909 0.801582 13.0909 1.09091V3.27273C13.0909 3.56205 12.976 3.83953 12.7714 4.04412C12.5668 4.2487 12.2893 4.36364 12 4.36364C11.7107 4.36364 11.4332 4.2487 11.2286 4.04412C11.024 3.83953 10.9091 3.56205 10.9091 3.27273V1.09091C10.9091 0.801582 11.024 0.524105 11.2286 0.31952C11.4332 0.114935 11.7107 0 12 0ZM5.45455 12C5.45455 10.264 6.14415 8.59918 7.37167 7.37167C8.59918 6.14415 10.264 5.45455 12 5.45455C13.736 5.45455 15.4008 6.14415 16.6283 7.37167C17.8558 8.59918 18.5455 10.264 18.5455 12C18.5455 13.736 17.8558 15.4008 16.6283 16.6283C15.4008 17.8558 13.736 18.5455 12 18.5455C10.264 18.5455 8.59918 17.8558 7.37167 16.6283C6.14415 15.4008 5.45455 13.736 5.45455 12ZM12 7.63636C10.8427 7.63636 9.73278 8.0961 8.91444 8.91444C8.0961 9.73278 7.63636 10.8427 7.63636 12C7.63636 13.1573 8.0961 14.2672 8.91444 15.0856C9.73278 15.9039 10.8427 16.3636 12 16.3636C13.1573 16.3636 14.2672 15.9039 15.0856 15.0856C15.9039 14.2672 16.3636 13.1573 16.3636 12C16.3636 10.8427 15.9039 9.73278 15.0856 8.91444C14.2672 8.0961 13.1573 7.63636 12 7.63636ZM13.0909 20.7273C13.0909 20.4379 12.976 20.1605 12.7714 19.9559C12.5668 19.7513 12.2893 19.6364 12 19.6364C11.7107 19.6364 11.4332 19.7513 11.2286 19.9559C11.024 20.1605 10.9091 20.4379 10.9091 20.7273V22.9091C10.9091 23.1984 11.024 23.4759 11.2286 23.6805C11.4332 23.8851 11.7107 24 12 24C12.2893 24 12.5668 23.8851 12.7714 23.6805C12.976 23.4759 13.0909 23.1984 13.0909 22.9091V20.7273ZM24 12C24 12.2893 23.8851 12.5668 23.6805 12.7714C23.4759 12.976 23.1984 13.0909 22.9091 13.0909H20.7273C20.4379 13.0909 20.1605 12.976 19.9559 12.7714C19.7513 12.5668 19.6364 12.2893 19.6364 12C19.6364 11.7107 19.7513 11.4332 19.9559 11.2286C20.1605 11.024 20.4379 10.9091 20.7273 10.9091H22.9091C23.1984 10.9091 23.4759 11.024 23.6805 11.2286C23.8851 11.4332 24 11.7107 24 12ZM3.27273 13.0909C3.56205 13.0909 3.83953 12.976 4.04412 12.7714C4.2487 12.5668 4.36364 12.2893 4.36364 12C4.36364 11.7107 4.2487 11.4332 4.04412 11.2286C3.83953 11.024 3.56205 10.9091 3.27273 10.9091H1.09091C0.801582 10.9091 0.524105 11.024 0.31952 11.2286C0.114935 11.4332 0 11.7107 0 12C0 12.2893 0.114935 12.5668 0.31952 12.7714C0.524105 12.976 0.801582 13.0909 1.09091 13.0909H3.27273ZM20.4851 3.51491C20.6896 3.71949 20.8045 3.99691 20.8045 4.28618C20.8045 4.57545 20.6896 4.85288 20.4851 5.05746L18.9425 6.6C18.8419 6.70419 18.7215 6.7873 18.5884 6.84447C18.4553 6.90165 18.3122 6.93174 18.1673 6.933C18.0225 6.93426 17.8788 6.90666 17.7448 6.85181C17.6107 6.79695 17.4889 6.71595 17.3865 6.61352C17.284 6.51109 17.203 6.38929 17.1482 6.25522C17.0933 6.12115 17.0657 5.9775 17.067 5.83265C17.0683 5.6878 17.0984 5.54465 17.1555 5.41156C17.2127 5.27846 17.2958 5.15809 17.4 5.05746L18.9425 3.51491C19.1471 3.3104 19.4245 3.19551 19.7138 3.19551C20.0031 3.19551 20.2805 3.3104 20.4851 3.51491ZM6.6 18.9425C6.70419 18.8419 6.7873 18.7215 6.84447 18.5884C6.90165 18.4553 6.93174 18.3122 6.933 18.1673C6.93426 18.0225 6.90666 17.8788 6.85181 17.7448C6.79695 17.6107 6.71595 17.4889 6.61352 17.3865C6.51109 17.284 6.38929 17.203 6.25522 17.1482C6.12115 17.0933 5.9775 17.0657 5.83265 17.067C5.6878 17.0683 5.54465 17.0984 5.41156 17.1555C5.27846 17.2127 5.15809 17.2958 5.05746 17.4L3.51491 18.9425C3.41072 19.0432 3.32761 19.1636 3.27043 19.2966C3.21326 19.4297 3.18317 19.5729 3.18191 19.7177C3.18065 19.8626 3.20825 20.0062 3.2631 20.1403C3.31796 20.2744 3.39896 20.3962 3.50139 20.4986C3.60382 20.601 3.72562 20.682 3.85969 20.7369C3.99376 20.7917 4.13741 20.8193 4.28226 20.8181C4.42711 20.8168 4.57026 20.7867 4.70335 20.7296C4.83645 20.6724 4.95682 20.5893 5.05746 20.4851L6.6 18.9425ZM3.51491 3.51491C3.71949 3.3104 3.99691 3.19551 4.28618 3.19551C4.57545 3.19551 4.85288 3.3104 5.05746 3.51491L6.6 5.05746C6.70419 5.15809 6.7873 5.27846 6.84447 5.41156C6.90165 5.54465 6.93174 5.6878 6.933 5.83265C6.93426 5.9775 6.90666 6.12115 6.85181 6.25522C6.79695 6.38929 6.71595 6.51109 6.61352 6.61352C6.51109 6.71595 6.38929 6.79695 6.25522 6.85181C6.12115 6.90666 5.9775 6.93426 5.83265 6.933C5.6878 6.93174 5.54465 6.90165 5.41156 6.84447C5.27846 6.7873 5.15809 6.70419 5.05746 6.6L3.51491 5.05746C3.3104 4.85288 3.19551 4.57545 3.19551 4.28618C3.19551 3.99691 3.3104 3.71949 3.51491 3.51491ZM18.9425 17.4C18.7368 17.2013 18.4612 17.0913 18.1752 17.0938C17.8892 17.0963 17.6156 17.211 17.4133 17.4133C17.211 17.6156 17.0963 17.8892 17.0938 18.1752C17.0913 18.4612 17.2013 18.7368 17.4 18.9425L18.9425 20.4851C19.1483 20.6838 19.4239 20.7938 19.7099 20.7913C19.9959 20.7888 20.2695 20.6741 20.4718 20.4718C20.6741 20.2695 20.7888 19.9959 20.7913 19.7099C20.7938 19.4239 20.6838 19.1483 20.4851 18.9425L18.9425 17.4Z"
          fill="black"
        />
      </svg>
    </>
  )
}

export const IconOne = () => {
  return (
    <>
      <svg
        width="70"
        height="62"
        viewBox="0 0 70 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="mx-auto"
      >
        <g filter="url(#filter0_d)">
          <path
            d="M25.8795 12.8542C35.6563 5.46211 49.3668 6.32086 58.1448 14.8751C61.8474 18.4833 64.3437 23.2354 65.2587 28.3238C67.6323 41.5225 59.5282 54.5651 46.5697 58.0172L46.1941 58.1173C43.9944 58.7033 41.7278 59 39.4514 59H7.74634C6.55027 59 5.95224 59 5.51619 58.9013C3.46162 58.4362 2.11987 56.4574 2.44821 54.3765C2.51789 53.9349 2.73922 53.3794 3.18189 52.2682L12.7966 28.1344C14.8063 23.0899 18.1586 18.6918 22.49 15.4169L25.8795 12.8542Z"
            fill="#E09143"
          />
        </g>
        <path
          d="M34.416 44V34.88C34.416 34.464 34.416 34.04 34.416 33.608C34.432 33.16 34.44 32.704 34.44 32.24C33.912 32.736 33.32 33.16 32.664 33.512C32.024 33.864 31.36 34.104 30.672 34.232L30.288 30.824C30.832 30.76 31.424 30.592 32.064 30.32C32.72 30.048 33.328 29.72 33.888 29.336C34.448 28.936 34.856 28.544 35.112 28.16H38.4V44H34.416Z"
          fill="#F9F7FC"
        />
        <defs>
          <filter
            id="filter0_d"
            x="1.39884"
            y="6.83618"
            width="67.2717"
            height="55.1639"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="1" dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  )
}

export const IconTwo = () => {
  return (
    <>
      <svg
        width="70"
        height="62"
        viewBox="0 0 70 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="mx-auto"
      >
        <g filter="url(#filter0_d)">
          <path
            d="M25.8795 12.8542C35.6563 5.46211 49.3668 6.32086 58.1448 14.8751C61.8474 18.4833 64.3437 23.2354 65.2587 28.3238C67.6323 41.5225 59.5282 54.5651 46.5697 58.0172L46.1941 58.1173C43.9944 58.7033 41.7278 59 39.4514 59H7.74634C6.55027 59 5.95224 59 5.51619 58.9013C3.46162 58.4362 2.11987 56.4574 2.44821 54.3765C2.51789 53.9349 2.73922 53.3794 3.18189 52.2682L12.7966 28.1344C14.8063 23.0899 18.1586 18.6918 22.49 15.4169L25.8795 12.8542Z"
            fill="#797E5E"
          />
        </g>
        <path
          d="M29.2916 44V41.36C31.0996 40.224 32.5556 39.192 33.6596 38.264C34.7796 37.32 35.5956 36.44 36.1076 35.624C36.6196 34.808 36.8756 34.032 36.8756 33.296C36.8756 32.688 36.6916 32.184 36.3236 31.784C35.9716 31.368 35.4436 31.16 34.7396 31.16C33.9876 31.16 33.3956 31.44 32.9636 32C32.5476 32.544 32.3316 33.344 32.3156 34.4L28.7876 33.32C28.8196 32.152 29.0996 31.168 29.6276 30.368C30.1716 29.552 30.9076 28.944 31.8356 28.544C32.7636 28.128 33.8196 27.92 35.0036 27.92C36.3956 27.92 37.5316 28.176 38.4116 28.688C39.2916 29.184 39.9396 29.824 40.3556 30.608C40.7716 31.376 40.9796 32.176 40.9796 33.008C40.9796 34.544 40.3956 35.944 39.2276 37.208C38.0596 38.456 36.4036 39.696 34.2596 40.928V40.952C34.6596 40.92 35.1636 40.896 35.7716 40.88C36.3956 40.864 36.9556 40.856 37.4516 40.856H41.1716V44H29.2916Z"
          fill="#F9F7FC"
        />
        <defs>
          <filter
            id="filter0_d"
            x="1.39884"
            y="6.83618"
            width="67.2717"
            height="55.1639"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="1" dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  )
}

export const IconThree = () => {
  return (
    <>
      <svg
        width="70"
        height="62"
        viewBox="0 0 70 62"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="mx-auto"
      >
        <g filter="url(#filter0_d)">
          <path
            d="M25.8795 12.8542C35.6563 5.46211 49.3668 6.32086 58.1448 14.8751C61.8474 18.4833 64.3437 23.2354 65.2587 28.3238C67.6323 41.5225 59.5282 54.5651 46.5697 58.0172L46.1941 58.1173C43.9944 58.7033 41.7278 59 39.4514 59H7.74634C6.55027 59 5.95224 59 5.51619 58.9013C3.46162 58.4362 2.11987 56.4574 2.44821 54.3765C2.51789 53.9349 2.73922 53.3794 3.18189 52.2682L12.7966 28.1344C14.8063 23.0899 18.1586 18.6918 22.49 15.4169L25.8795 12.8542Z"
            fill="#254B5B"
          />
        </g>
        <path
          d="M35.1107 44.24C33.4147 44.24 32.0067 43.912 30.8867 43.256C29.7667 42.584 28.9827 41.608 28.5347 40.328L32.3267 38.696C32.4227 39.56 32.6947 40.168 33.1427 40.52C33.6067 40.872 34.2067 41.048 34.9427 41.048C35.5987 41.048 36.1187 40.88 36.5027 40.544C36.8867 40.192 37.0787 39.72 37.0787 39.128C37.0787 38.52 36.8947 38.08 36.5267 37.808C36.1587 37.536 35.6387 37.4 34.9667 37.4C34.5827 37.4 34.1907 37.424 33.7907 37.472V34.784C33.9187 34.8 34.0467 34.816 34.1747 34.832C34.3027 34.832 34.4547 34.832 34.6307 34.832C35.3667 34.832 35.9027 34.68 36.2387 34.376C36.5747 34.056 36.7427 33.56 36.7427 32.888C36.7427 32.312 36.5747 31.872 36.2387 31.568C35.9187 31.264 35.4627 31.112 34.8707 31.112C34.2307 31.112 33.7107 31.28 33.3107 31.616C32.9267 31.952 32.6787 32.504 32.5667 33.272L28.9427 32.024C29.1187 31.144 29.4947 30.4 30.0707 29.792C30.6467 29.184 31.3667 28.72 32.2307 28.4C33.1107 28.08 34.0787 27.92 35.1347 27.92C36.9427 27.92 38.3267 28.312 39.2867 29.096C40.2627 29.88 40.7507 30.936 40.7507 32.264C40.7507 32.952 40.6387 33.528 40.4147 33.992C40.2067 34.456 39.9347 34.832 39.5987 35.12C39.2787 35.408 38.9507 35.624 38.6147 35.768C38.2787 35.896 37.9987 35.976 37.7747 36.008V36.08C38.0627 36.08 38.3907 36.136 38.7587 36.248C39.1267 36.36 39.4867 36.544 39.8387 36.8C40.1907 37.056 40.4787 37.4 40.7027 37.832C40.9427 38.248 41.0627 38.776 41.0627 39.416C41.0627 40.408 40.7987 41.264 40.2707 41.984C39.7587 42.704 39.0547 43.264 38.1587 43.664C37.2627 44.048 36.2467 44.24 35.1107 44.24Z"
          fill="#F9F7FC"
        />
        <defs>
          <filter
            id="filter0_d"
            x="1.39884"
            y="6.83618"
            width="67.2717"
            height="55.1639"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="1" dy="1" />
            <feGaussianBlur stdDeviation="1" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  )
}

export const IconLine = () => (
  <svg
    width="1"
    height="48"
    viewBox="0 0 1 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="lg:hidden mx-auto pt-1"
  >
    <line
      x1="0.5"
      y1="48"
      x2="0.5"
      y2="-1.90735e-06"
      stroke="#8C8CA1"
      stroke-dasharray="2 2"
    />
  </svg>
)
